import { MarketingPortals } from 'types/property';

export const MARKETING_PORTAL_TAGS = {
  [MarketingPortals.RIGHTMOVE]: 'RIGHTMOVE',
  [MarketingPortals.ZOOPLA]: 'ZOOPLA',
  [MarketingPortals.SAVILLS]: 'SAVILLS WEBSITE',
};

export const MarketingReportID = 'marketingReport';
